<div class="[height:calc(100%-3.09769rem)]">
  <ng-container *ngIf="currentStep <= 3">
    <div
      id="section1"
      class="section-panel h-[100%]"
      style="background-color: #ffffff"
    >
      <ng-container>
        <ng-container *ngTemplateOutlet="Stage1Components"></ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="currentStep >= 4">
    <div
      id="section2"
      class="section-panel h-[100%]"
      style="background-color: #ffffff"
    >
      <ng-container>
        <ng-container *ngTemplateOutlet="ProjectPlanComponents"></ng-container>
      </ng-container>
    </div>
  </ng-container>
</div>
<!-- Stage 1  Components -->
<ng-template #Stage1Components>
  <app-project-brief
    class="h-full w-full"
    [currentStep]="currentStep"
    [projectId]="projectId"
    (projectIdEmitter)="receiveProjectId($event)"
  ></app-project-brief>
</ng-template>
<!-- Stage 2 Components -->
<ng-template #ProjectPlanComponents>
  <app-plan-sections
    class="w-full h-full"
    [currentStep]="currentStep"
  ></app-plan-sections>
</ng-template>
